import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthContextProvider } from './context/AuthContext';
import { ExerciseContextProvider} from './context/ExericseContext';
import { RoutineContextProvider } from './context/RoutineContext';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <AuthContextProvider>
        <ExerciseContextProvider>
            <RoutineContextProvider>
                <App/>
            </RoutineContextProvider>

        </ExerciseContextProvider>
    </AuthContextProvider>


);


